module.exports = __webpack_public_path__ + "img/10101404.9de61b73.png";